"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STORE_PAYOUT_STATUS = void 0;
exports.STORE_PAYOUT_STATUS = {
    REQUESTED: 'REQUESTED',
    PROCESSED: 'PROCESSED',
    DECLINED: 'DECLINED'
};
//# sourceMappingURL=storePayoutStatus.js.map